/**
 * Zobyda cart drawer: quick-add for the "Complete your routine" rows (snippets/zb-cart-upsell.liquid).
 * Loaded from snippets/header-actions.liquid on every page that has the cart drawer, because the rows
 * often arrive later inside re-rendered drawer HTML, where inline scripts would not run.
 * Adds one unit, then hands the fresh drawer HTML to the theme's own cart:update flow
 * (cart-items-component re-renders the drawer, cart-icon updates the header count).
 * Built 10 Oct 2026.
 */
(function () {
  'use strict';
  if (window.__zbCartInit) return;
  window.__zbCartInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function itemCountFrom(html) {
    if (!html) return null;
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[ref="cartItemCount"]');
    var n = el ? parseInt(el.textContent, 10) : NaN;
    return isNaN(n) ? null : n;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-zb-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var label = button.innerHTML;
    var host = document.querySelector('cart-items-component[data-drawer]');
    var sectionId = host ? host.dataset.sectionId : null;
    var body = { items: [{ id: parseInt(button.getAttribute('data-zb-add'), 10), quantity: 1 }] };
    if (sectionId) {
      body.sections = sectionId;
      body.sections_url = window.location.pathname;
    }

    button.disabled = true;
    button.classList.remove('is-error');
    button.removeAttribute('title');
    button.textContent = 'Adding…';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function (data) {
        var sections = data.sections || {};
        var count = itemCountFrom(sectionId ? sections[sectionId] : null);
        var countReady = count !== null
          ? Promise.resolve(count)
          : fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) { return cart.item_count; });

        return countReady.then(function (itemCount) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: 'zb-cart-upsell',
              data: { itemCount: itemCount, source: 'zb-cart-upsell', sections: sections }
            }
          }));
        });
      })
      .catch(function () {
        button.disabled = false;
        button.classList.add('is-error');
        button.innerHTML = label;
        button.setAttribute('title', 'That didn’t go through. Please try again.');
      });
  });

  /*
   * The Full Edit landing page (/pages/full-edit). Added 16 Oct 2026.
   * Its "Get the Full Edit" buttons link to the product page with the shade already picked
   * (/products/the-full-edit?variant=...). A plain click now puts that shade in the bag through
   * Shopify's cart and goes straight to checkout. A shade that is already in the bag is not added
   * twice. If anything fails, the link opens the product page, as before.
   * Ctrl/Cmd/Shift/Alt-clicks and middle-clicks are left alone.
   */
  function feLabelNode(link) {
    for (var node = link.firstChild; node; node = node.nextSibling) {
      if (node.nodeType === 3 && node.textContent.trim()) return node;
    }
    return null;
  }

  function feRestore(link) {
    var node = feLabelNode(link);
    if (node && link.hasAttribute('data-zb-label')) node.textContent = link.getAttribute('data-zb-label');
    link.removeAttribute('data-zb-label');
    link.removeAttribute('data-zb-busy');
    link.removeAttribute('aria-busy');
  }

  window.addEventListener('pageshow', function () {
    var busy = document.querySelectorAll('.ze-cta a[data-zb-busy]');
    for (var i = 0; i < busy.length; i++) feRestore(busy[i]);
  });

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest && event.target.closest('.ze-cta a[href*="/products/the-full-edit"]');
    if (!link) return;
    var found = /[?&]variant=(\d+)/.exec(link.getAttribute('href') || '');
    if (!found) return;
    event.preventDefault();
    if (link.hasAttribute('data-zb-busy')) return;

    var variantId = parseInt(found[1], 10);
    var go = window.zbFullEditGo || function (url) { window.location.href = url; };
    var node = feLabelNode(link);
    if (node) {
      link.setAttribute('data-zb-label', node.textContent);
      node.textContent = link.querySelector('small') ? 'Adding to your bag…' : 'Adding…';
    }
    link.setAttribute('data-zb-busy', '');
    link.setAttribute('aria-busy', 'true');

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : { items: [] };
      })
      .then(function (cart) {
        var inBag = (cart.items || []).some(function (item) {
          return item.variant_id === variantId;
        });
        if (inBag) return null;
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        }).then(function (response) {
          if (!response.ok) throw new Error('add failed');
          return null;
        });
      })
      .then(function () {
        go(root + 'checkout');
      })
      .catch(function () {
        feRestore(link);
        go(link.href);
      });
  });

  /*
   * The Full Edit landing page also offers Subscribe & save (30 Oct 2026). That lives in
   * assets/zb-fe-buy.js, which product pages load themselves; this page gets it from here.
   * With Subscribe & save picked it handles the buttons first; One-time still runs the code above.
   */
  if (/^\/pages\/full-edit\/?$/.test(window.location.pathname) && !window.__zbFeBuy) {
    var me = document.currentScript || document.querySelector('script[src*="zb-cart.js"]');
    if (me && me.src) {
      /* An hourly token, so browsers don't keep an old copy after the files change */
      var base = me.src.split('?')[0];
      var token = '?v=' + Math.floor(Date.now() / 3600000);
      var feCss = document.createElement('link');
      feCss.rel = 'stylesheet';
      feCss.href = base.replace('zb-cart.js', 'zb-fe-buy.css') + token;
      document.head.appendChild(feCss);
      var feBuy = document.createElement('script');
      feBuy.src = base.replace('zb-cart.js', 'zb-fe-buy.js') + token;
      feBuy.defer = true;
      document.head.appendChild(feBuy);
    }
  }
})();
